import FMTable from './FMTable';
export default FMTable;